// javascript/utils/xmlSanitizer.ts

//  list of valid xml 1.0 characters: https://www.w3.org/TR/xml/#charsets
//  #x9 | #xA | #xD
//  | [#x20-#xD7FF]
//  | [#xE000-#xFFFD]
//  | [#x10000-#x10FFFF]

const ALLOWED_XML_CHARS = /[\u0009\u000A\u000D\u0020-\uD7FF\uE000-\uFFFD\u{10000}-\u{10FFFF}]/u;

export function sanitizeXML(input: string): {
  cleaned: string
  removedCodes: string[]
} {
  const chars = Array.from(input);
  const removedChars = chars.filter(ch => !ALLOWED_XML_CHARS.test(ch));
  const removedCodes = Array.from(
    new Set(
      removedChars.map(ch =>
        "U+" + ch.codePointAt(0)!.toString(16).toUpperCase().padStart(4, "0")
      )
    )
  );

  // Rebuild the cleaned string from only allowed chars
  const cleaned = chars.filter(ch => ALLOWED_XML_CHARS.test(ch)).join("");
  return { cleaned, removedCodes };
}
